import { __assign, __read, __spreadArray } from "tslib";
import { Typography } from '../Typography/Typography';
import { makeCssObjectOfTextStyle } from '../Typography/Typography.utils';
var FONT_FAMILY = '"LeasePlan", Helvetica, Arial, sans-serif';
var typography = function (velocityBaseMuiTheme, velocityTheme) {
    var _a, _b, _c;
    var _mapResponsiveFontsToMui = mapResponsiveFontsToMui.bind(null, velocityBaseMuiTheme.breakpoints, velocityTheme);
    return {
        fontFamily: FONT_FAMILY,
        fontSize: 14,
        fontWeightLight: 400,
        fontWeightRegular: 600,
        fontWeightMedium: 800,
        fontWeightBold: 800,
        h1: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.headline['600']; })),
        h2: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.headline['500']; })),
        h3: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.headline['400']; })),
        h4: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.headline['300']; })),
        h5: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.headline['200']; })),
        h6: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.headline['100']; })),
        subtitle1: __assign(__assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['300']; }, 'loose')), (_a = { fontWeight: 800 }, _a[velocityBaseMuiTheme.breakpoints.up('sm')] = {
            fontWeight: 800,
        }, _a[velocityBaseMuiTheme.breakpoints.up('md')] = {
            fontWeight: 800,
        }, _a[velocityBaseMuiTheme.breakpoints.up('lg')] = {
            fontWeight: 800,
        }, _a[velocityBaseMuiTheme.breakpoints.up('xl')] = {
            fontWeight: 800,
        }, _a)),
        subtitle2: __assign(__assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['200']; }, 'loose')), (_b = { fontFamily: FONT_FAMILY, letterSpacing: 0, fontWeight: 800 }, _b[velocityBaseMuiTheme.breakpoints.up('sm')] = {
            fontWeight: 800,
        }, _b[velocityBaseMuiTheme.breakpoints.up('md')] = {
            fontWeight: 800,
        }, _b[velocityBaseMuiTheme.breakpoints.up('lg')] = {
            fontWeight: 800,
        }, _b[velocityBaseMuiTheme.breakpoints.up('xl')] = {
            fontWeight: 800,
        }, _b)),
        body1: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['300']; })),
        body2: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['200']; })),
        body3: __assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['100']; })),
        button: __assign(__assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['100']; }, 'loose')), (_c = { fontFamily: FONT_FAMILY, textTransform: 'uppercase', letterSpacing: '0.05375em', fontWeight: 800 }, _c[velocityBaseMuiTheme.breakpoints.up('sm')] = {
            fontWeight: 800,
        }, _c[velocityBaseMuiTheme.breakpoints.up('md')] = {
            fontWeight: 800,
        }, _c[velocityBaseMuiTheme.breakpoints.up('lg')] = {
            fontWeight: 800,
        }, _c[velocityBaseMuiTheme.breakpoints.up('xl')] = {
            fontWeight: 800,
        }, _c)),
        caption: __assign(__assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['100']; })), { fontWeight: 600, lineHeight: 1.66, letterSpacing: '0.03333em', color: velocityTheme.styling.secondary.dark.default }),
        overline: __assign(__assign({}, _mapResponsiveFontsToMui(function (config) { return config.text['100']; })), { fontWeight: 600, lineHeight: 2.66, letterSpacing: '0.08333em', textTransform: 'uppercase', color: velocityTheme.styling.secondary.dark.default }),
    };
};
export default typography;
function mapResponsiveFontsToMui(breakpoints, velocityTheme, styleGetter) {
    var textSubVariants = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        textSubVariants[_i - 3] = arguments[_i];
    }
    var mobileFirstStyle = makeCssObjectOfTextStyle.apply(void 0, __spreadArray([styleGetter(Typography.mobile),
        velocityTheme], __read(textSubVariants)));
    return breakpoints.keys.reduce(function (acc, key) {
        var _a;
        if (key === 'xs')
            return acc;
        var velocityKey = mapBreakpoint(key);
        if (!velocityKey)
            return acc;
        return __assign(__assign({}, acc), (_a = {}, _a[breakpoints.up(key)] = makeCssObjectOfTextStyle.apply(void 0, __spreadArray([styleGetter(Typography[velocityKey]),
            velocityTheme], __read(textSubVariants))), _a));
    }, mobileFirstStyle);
}
function mapBreakpoint(muiBreakpointName) {
    switch (muiBreakpointName) {
        case 'xs':
            return 'mobile';
        case 'md':
            return 'tablet';
        case 'xl':
            return 'desktop';
        default:
            return null;
    }
}
//# sourceMappingURL=typography.js.map